import React, { useState, useEffect } from "react";
import {
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
  Label,
} from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import "../ReportsDateSelect/ReportsDateSelect.scss";
import { DownDropArrow } from "../../../assets/images";
import { CalenderIcon } from "../../Icon";
import {
  getCurrentFinancialYear,
  previousFinancialYear,
} from "../../../utils/commonFunctions";

type AppProps = {
  toggle: boolean;
  setToggle: (data: boolean) => void;
  startDate: string;
  type?: string;
  endDate: string;
  setOffset: (data: number) => void;
  resetData: () => void;
  applyDate: (start: string, end: string) => void;
  handleStartDateChange: (date: string) => void;
  handleEndDateChange: (date: string) => void;
};
const GstDateSelect = ({
  toggle,
  setToggle,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  type,
  applyDate,
  setOffset,
  resetData,
}: AppProps) => {
  const [text, setText] = useState<string>("");
  const [chooseStartDate, setChooseStartDate] = useState("");
  const [chooseEndDate, setChooseEndDate] = useState("");
  const [persistStartDate, setPersistStartDate] = useState("");
  const [persistEndDate, setPersistEndDate] = useState("");
  const currentFY = getCurrentFinancialYear();
  const previousFY = previousFinancialYear();
  const [difference, setDifference] = useState(0);

  useEffect(() => {
    setChooseStartDate("");
    setChooseEndDate("");
    if (!startDate && !endDate) {
      handleStartDateChange(`${currentFY?.split("-")[0]}-04-01`);
      handleEndDateChange(`${currentFY?.split("-")[1]}-03-31`);
      setText("Current FY");
    }
  }, []);

  useEffect(() => {
    if (chooseStartDate && chooseEndDate) {
      let splitedStart: any = chooseStartDate?.split("-");
      let splitedEnd: any = chooseEndDate?.split("-");

      let date1: any = new Date(
        `${splitedStart[0]}/${splitedStart[1]}/${splitedStart[2]}`
      );
      let date2: any = new Date(
        `${splitedEnd[0]}/${splitedEnd[1]}/${splitedEnd[2]}`
      );

      setDifference(
        parseInt(((date2 - date1) / (1000 * 60 * 60 * 24)).toString(), 10)
      );

      const startDatetext = new Date(chooseStartDate).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const endDatetext = new Date(chooseEndDate).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      setText(`${startDatetext} - ${endDatetext}`);
    } else if (!chooseStartDate) {
      handleStartDateChange(`${currentFY?.split("-")[0]}-04-01`);
      handleEndDateChange(`${currentFY?.split("-")[1]}-03-31`);
      setText("Current FY");
      setPersistEndDate("");
    }
  }, [chooseEndDate, chooseStartDate]);

  const checkText = () => {
    if (
      startDate == `${currentFY?.split("-")[0]}-04-01` &&
      endDate == `${currentFY?.split("-")[1]}-03-31`
    ) {
      setText("Current FY");
      setChooseStartDate("");
      setChooseEndDate("");
    } else if (
      startDate == `${previousFY?.split("-")[0]}-04-01` &&
      endDate == `${previousFY?.split("-")[1]}-03-31`
    ) {
      setText("Previous FY");
      setChooseStartDate("");
      setChooseEndDate("");
    } else if (startDate && endDate) {
      const startDatetext = new Date(startDate).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const endDatetext = new Date(endDate).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      setChooseStartDate(startDate);
      setChooseEndDate(endDate);
      setText(`${startDatetext} - ${endDatetext}`);
    } else {
      handleStartDateChange(`${currentFY?.split("-")[0]}-04-01`);
      handleEndDateChange(`${currentFY?.split("-")[1]}-03-31`);
      setText("Current FY");
    }
  };

  const startDateChange = (date: string) => {
    if (date === "Invalid date") {
      setChooseStartDate("");
      setChooseEndDate("");
      setPersistStartDate("");
    } else {
      setChooseStartDate(date);
      setPersistStartDate(date);
    }
  };
  const endDateChange = (date: string) => {
    if (date === "Invalid date") {
      setChooseEndDate("");
      setPersistEndDate("");
    } else {
      setChooseEndDate(date);
      setPersistEndDate(date);
    }
  };
  const handleCurrentYear = () => {
    setText("Current FY");
    setPersistStartDate(`${currentFY?.split("-")[0]}-04-01`);
    setPersistEndDate(`${currentFY?.split("-")[1]}-03-31`);
    setChooseStartDate("");
    setChooseEndDate("");
  };
  const handlePreviousYear = () => {
    setText("Previous FY");
    setPersistStartDate(`${previousFY?.split("-")[0]}-04-01`);
    setPersistEndDate(`${previousFY?.split("-")[1]}-03-31`);
    setChooseStartDate("");
    setChooseEndDate("");
  };

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle);
        checkText();
      }}
    >
      <DropdownToggle
        caret
        color="#262a44"
        style={{
          border: "1px solid #bfcbe1",
          backgroundColor: "#ffffff",
          height: "38px",
        }}
      >
        <span style={{ fontSize: "16px" }}>{text}</span>{" "}
        <img src={DownDropArrow} alt="" />
      </DropdownToggle>
      <DropdownMenu
        style={{
          width: "350px",
          padding: "31px 25px 30px",
          position: "absolute",
        }}
        right
      >
        <span>Select Date</span>
        <div className="row mt-3">
          <div
            className={`${type === "balanceSheet" ? "col-md-12" : "col-md-6"}`}
          >
            <div className="form-group">
              <div className="date-picker-wraper mr-0">
                <Label className="m-0 p-0 w-100">
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={
                      chooseStartDate
                        ? new Date(
                            moment(
                              `${chooseStartDate}T00:00:00`,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      startDateChange(moment(e).format("YYYY-MM-DD"));
                    }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    // onInputClick={()=>setText(chooseStartDate)}
                    name="startDate"
                    placeholderText={
                      type === "balanceSheet" ? "Choose Date" : "Start Date"
                    }
                    className="form-control"
                  />
                  <span
                    className="calender-icon"
                    style={{ top: "5px", right: "20px", cursor: "pointer" }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>
          </div>
          {
            <div className="col-md-6">
              <div className="form-group">
                <div className="date-picker-wraper mr-0">
                  <Label className="m-0 p-0 w-100">
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      selected={
                        chooseEndDate
                          ? new Date(
                              moment(
                                `${chooseEndDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      onChange={(e: any) => {
                        endDateChange(moment(e).format("YYYY-MM-DD"));
                      }}
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      name="endDate"
                      placeholderText="End Date"
                      className="form-control"
                      disabled={!chooseStartDate}
                      minDate={
                        chooseStartDate
                          ? new Date(
                              moment(
                                `${chooseStartDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                    />
                    <span
                      className="calender-icon"
                      style={{ top: "5px", right: "20px", cursor: "pointer" }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
          }
        </div>
        <button
          id="current"
          className="btn btn-outline-secondary col-md-12 mb-2"
          onClick={() => handleCurrentYear()}
          style={{
            color: text === "Current FY" ? "red" : "",
            borderColor: text === "Current FY" ? "red" : "",
          }}
        >
          Current FY
        </button>
        <button
          id="previous"
          className="btn btn-outline-secondary col-md-12"
          onClick={() => handlePreviousYear()}
          style={{
            color: text === "Previous FY" ? "red" : "",
            borderColor: text === "Previous FY" ? "red" : "",
          }}
        >
          Previous FY
        </button>

        <div className="d-flex align-items-center justify-content-end pt-3 ">
          <button
            className="btn btn-primary"
            onClick={() => {
              setOffset(0);
              resetData();
              handleStartDateChange(
                persistStartDate
                  ? persistStartDate
                  : `${currentFY?.split("-")[0]}-04-01`
              );
              handleEndDateChange(
                persistEndDate
                  ? persistEndDate
                  : `${currentFY?.split("-")[1]}-03-31`
              );
              applyDate(
                persistStartDate
                  ? persistStartDate
                  : `${currentFY?.split("-")[0]}-04-01`,
                persistEndDate
                  ? persistEndDate
                  : `${currentFY?.split("-")[1]}-03-31`
              );
              setToggle(!toggle);
            }}
            disabled={
              (!!chooseStartDate?.length && !chooseEndDate?.length) ||
              (!chooseStartDate?.length && !!chooseEndDate?.length) ||
              (!!chooseStartDate?.length &&
                !!chooseEndDate?.length &&
                difference <= 0)
            }
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default GstDateSelect;
